// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Api from './router/Api'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import qs from 'qs'
import axios from 'axios'
import VueAxios from "vue-axios"
import VueCookies from 'vue-cookies'
import {VueJsonp} from 'vue-jsonp'

import customConfig from './common/constants'
import "./assets/css/common.css";


//引用kindeditor富文本编辑器
import VueKindEditor from './plugin/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all-min.js'
import '../static/kindeditor/lang/zh-CN.js'
Vue.use(VueKindEditor)


Vue.config.productionTip = false
Vue.prototype.apiRear = Api.serverUrl+'admin/' // 注册全局api
Vue.prototype.apiFront = Api.serverUrl+'api/' // 注册全局api
Vue.prototype.h5url = Api.serverH5 
Vue.prototype.Host = Api.serverHost // 注册全局
Vue.prototype.urlFileview = Api.urlFileview // 注册全局文件预览地址

Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueJsonp)
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs
Vue.prototype.$customConfig = customConfig
Vue.prototype.$formAttrs = {querySize:'mini',editSize:'small', labelWidth:'60px', elmWidth:'200px'}//medium / small / mini / large
axios.defaults.withCredentials = true // 设置允许携带cookie

Vue.prototype.$store = store
// /* 初始化数据 */
store.dispatch('SYSTEM_INIT');


// 响应拦截器
axios.interceptors.response.use(
    response => {
		//console.log(ElementUI.Message)//'success', 'warning', 'info', 'error'
        if (response.status === 200) {
			if(response.data.msg){
				ElementUI.Message.info(response.data.msg);
			}
            // 这里可以根据code值进行判断处理，需要与后端协商统一
			if(response.data.code==30001 || response.data.code==30002 || response.data.code==30003){
				sessionStorage.clear();
				router.push({ path: "/login" });
				
			}
        } else {
			if(response.data.msg){
				ElementUI.Message.error(response.data.msg);
			}
			sessionStorage.clear();
			router.push({ path: "/login" });
        }
         return Promise.resolve(response);
    },
    error => {
        if (error.response.status) {
			if(response.data.msg){
				ElementUI.Message.error(response.data.msg);
			}
			sessionStorage.clear();
			router.push({ path: "/login" });
            return Promise.reject(error.response);
        }
    }
);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js